var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _circle2, _circle3, _path79, _path80, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 868,
    viewBox: "0 0 1440 868",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1161.19 417.38C1161.19 417.38 1131.9 486.875 1053.74 441.896C975.574 396.916 969.174 351.085 819.191 395.213C669.208 439.341 614.733 436.683 582.656 386.052C550.58 335.421 490.091 265.127 362.172 272.507C234.253 279.887 168.397 106.912 76.1933 78.8351C-16.0105 50.7585 -82.8215 137.388 -82.8215 137.388V1028.98H1641C1641 1028.98 1596.95 892.67 1498.04 851.226C1399.12 809.782 1413.32 781.757 1404.23 712.262C1395.15 642.767 1205.17 595.93 1218.43 493.868C1231.7 391.807 1161.19 417.38 1161.19 417.38Z",
    fill: "url(#paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M-52.9642 150.627C-42.2806 143.891 144.785 99.0152 203.596 225.463C262.407 351.911 324.728 353.485 419.177 361.253C513.626 369.02 485.111 370.595 590.243 438.412C695.376 506.229 757.103 470.953 833.72 446.721C910.337 422.49 1032.6 480.578 1130.49 430.051C1228.37 379.523 1232.21 462.463 1232.21 462.463C1232.21 462.463 1205.01 534.719 1284.11 585.453C1363.2 636.187 1324.36 694.43 1346.38 787.099C1368.39 879.767 1582.45 1016.95 1582.45 1016.95L-92.1631 929.624L-52.9642 150.627Z",
    fill: "url(#paint1_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.036 176.406C-28.036 176.406 2.69859 319.319 132.321 335.421C261.943 351.524 265.968 346.698 315.412 411.884C364.856 477.069 391.565 513.61 479.769 489.997C567.973 466.385 645.467 410.697 717.62 455.908C789.773 501.12 949.639 577.711 1114.43 399.858C1279.23 222.005 1225.19 489.997 1225.19 489.997C1225.19 489.997 1110.98 589.479 1277.55 678.844C1336.31 712.262 1326.76 811.95 1346.12 876.567C1365.47 941.185 1523.87 1065.93 1523.87 1065.93C1523.87 1065.93 310.225 1166.78 302.2 1168.12C294.174 1169.46 -159 919.379 -159 919.379L-28.036 176.406Z",
    fill: "url(#paint2_radial)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1146.8,
    cy: 815.791,
    r: 28.025,
    transform: "rotate(-45 1146.8 815.791)",
    fill: "url(#paint3_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M641.803 516.113L643.713 519.622L647.248 521.558L643.713 523.467L641.803 527.003L639.867 523.467L636.358 521.558L639.867 519.622L641.803 516.113Z",
    fill: "#FEA7AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M847.242 757.345L848.507 759.667L850.804 760.906L848.507 762.17L847.242 764.493L845.978 762.17L843.681 760.906L845.978 759.667L847.242 757.345Z",
    fill: "#FEA7AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M850.803 551.002L852.068 553.299L854.365 554.563L852.068 555.828L850.803 558.125L849.539 555.828L847.242 554.563L849.539 553.299L850.803 551.002Z",
    fill: "#FEA7AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M334.018 857.316L335.283 859.613L337.579 860.877L335.283 862.116L334.018 864.438L332.754 862.116L330.457 860.877L332.754 859.613L334.018 857.316Z",
    fill: "#FEA7AF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M242.589 446.928L243.853 449.224L246.15 450.489L243.853 451.753L242.589 454.05L241.35 451.753L239.027 450.489L241.35 449.224L242.589 446.928Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M125.56 493.972L126.824 496.268L129.121 497.533L126.824 498.797L125.56 501.094L124.295 498.797L121.999 497.533L124.295 496.268L125.56 493.972Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M412.751 593.014L414.016 595.311L416.338 596.575L414.016 597.84L412.751 600.136L411.513 597.84L409.19 596.575L411.513 595.311L412.751 593.014Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M530.529 650.096L533.032 654.664L537.599 657.167L533.032 659.644L530.529 664.212L528.051 659.644L523.484 657.167L528.051 654.664L530.529 650.096Z",
    fill: "#FEA7AF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M152.914 401.51L155.391 406.052L159.959 408.555L155.391 411.058L152.914 415.6L150.41 411.058L145.869 408.555L150.41 406.052L152.914 401.51Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1146.77 596.575L1149.27 601.117L1153.81 603.62L1149.27 606.123L1146.77 610.665L1144.29 606.123L1139.72 603.62L1144.29 601.117L1146.77 596.575Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M166.565 850.4L167.752 852.568L169.92 853.729L167.752 854.916L166.565 857.084L165.378 854.916L163.236 853.729L165.378 852.568L166.565 850.4Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M671.583 823.846L672.77 826.014L674.937 827.201L672.77 828.362L671.583 830.53L670.396 828.362L668.254 827.201L670.396 826.014L671.583 823.846Z",
    fill: "#FEA7AF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M956.142 554.796L957.329 556.938L959.497 558.125L957.329 559.312L956.142 561.479L954.981 559.312L952.813 558.125L954.981 556.938L956.142 554.796Z",
    fill: "#FEA7AF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1091.57 761.138L1092.76 763.306L1094.93 764.493L1092.76 765.654L1091.57 767.822L1090.38 765.654L1088.24 764.493L1090.38 763.306L1091.57 761.138Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1008.94 471.03L1010.13 473.198L1012.27 474.359L1010.13 475.546L1008.94 477.714L1007.75 475.546L1005.59 474.359L1007.75 473.198L1008.94 471.03Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M730.471 627.413L732.613 631.361L736.536 633.503L732.613 635.645L730.471 639.593L728.304 635.645L724.381 633.503L728.304 631.361L730.471 627.413Z",
    fill: "#FEA7AF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M501.988 842.839L504.929 848.207L510.297 851.149L504.929 854.09L501.988 859.458L499.046 854.09L493.652 851.149L499.046 848.207L501.988 842.839Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M967.961 845.368L968.994 847.252L970.903 848.31L968.994 849.342L967.961 851.252L966.929 849.342L965.02 848.31L966.929 847.252L967.961 845.368Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.02 636.651L1023.08 638.535L1024.97 639.593L1023.08 640.625L1022.02 642.535L1020.99 640.625L1019.08 639.593L1020.99 638.535L1022.02 636.651Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M292.394 641.451L294.278 644.883L297.684 646.741L294.278 648.625L292.394 652.032L290.51 648.625L287.104 646.741L290.51 644.883L292.394 641.451Z",
    fill: "#FEA7AF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M850.803 853.29L852.145 855.742L854.597 857.084L852.145 858.426L850.803 860.877L849.461 858.426L847.01 857.084L849.461 855.742L850.803 853.29Z",
    fill: "#FEA7AF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M905.821 653.374L907.163 655.825L909.615 657.167L907.163 658.509L905.821 660.935L904.479 658.509L902.028 657.167L904.479 655.825L905.821 653.374Z",
    fill: "#FEA7AF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M699.35 710.198L700.692 712.649L703.143 713.991L700.692 715.333L699.35 717.785L698.034 715.333L695.582 713.991L698.034 712.649L699.35 710.198Z",
    fill: "#FEA7AF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1240.34 743.281L1241.68 745.732L1244.13 747.074L1241.68 748.416L1240.34 750.867L1239 748.416L1236.57 747.074L1239 745.732L1240.34 743.281Z",
    fill: "#FEA7AF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.226 543.596C279.098 555.432 266.967 562.491 255.131 559.363C243.295 556.234 236.236 544.103 239.364 532.267C242.492 520.431 254.623 513.372 266.459 516.5C272.143 518.002 276.998 521.701 279.954 526.782C282.911 531.864 283.729 537.912 282.226 543.596Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.826 537.48C283.826 537.48 286.097 538.151 289.942 539.57C291.877 540.293 294.2 541.196 296.832 542.409C299.879 543.667 302.703 545.41 305.193 547.57C306.053 548.334 306.566 549.414 306.613 550.563C306.642 550.769 306.642 550.977 306.613 551.183V551.492C306.428 551.82 306.193 552.116 305.916 552.37C305.47 552.745 304.964 553.041 304.419 553.247C302.443 553.895 300.382 554.243 298.303 554.28C293.991 554.413 289.675 554.189 285.4 553.609C267.008 551.224 249.001 546.471 231.828 539.467C227.853 537.856 224.013 535.932 220.344 533.712C218.559 532.649 216.942 531.327 215.544 529.79C215.165 529.351 214.876 528.843 214.693 528.293C214.386 527.648 214.386 526.899 214.693 526.255C215.001 525.709 215.457 525.262 216.009 524.964C216.459 524.717 216.935 524.518 217.428 524.371C220.665 523.722 223.985 523.6 227.26 524.009C230.124 524.267 232.602 524.629 234.64 524.938C238.692 525.609 240.989 526.151 240.989 526.151C240.989 526.151 238.64 525.893 234.563 525.532C232.524 525.351 230.047 525.171 227.208 525.145C224.096 524.993 220.977 525.28 217.944 525.996C217.583 526.11 217.236 526.266 216.912 526.461C216.757 526.461 216.602 526.642 216.602 526.693H216.473C216.436 526.79 216.393 526.885 216.344 526.977C216.138 527.235 216.344 527.906 216.964 528.5C218.273 529.806 219.769 530.91 221.402 531.777C225.084 533.715 228.875 535.438 232.757 536.938C241.262 540.25 249.967 543.025 258.82 545.248C267.614 547.686 276.552 549.574 285.581 550.899C289.701 551.512 293.855 551.874 298.019 551.983C301.658 551.983 306.974 551.389 303.929 548.628C301.607 546.499 299.001 544.702 296.187 543.286C293.606 541.919 291.465 540.861 289.607 540.009C286.02 538.383 283.826 537.48 283.826 537.48Z",
    fill: "url(#paint5_linear)"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M361.733 663.206L462.531 755.745C463.068 756.288 463.068 757.163 462.531 757.706C462.024 758.276 461.159 758.344 460.569 757.861L356.65 668.805C355.883 668.152 355.412 667.216 355.344 666.211C355.276 665.205 355.617 664.215 356.288 663.464C356.959 662.679 357.924 662.207 358.955 662.158C359.986 662.109 360.992 662.488 361.733 663.206Z",
    fill: "url(#paint6_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M399.41 698.662L461.189 755.435C461.51 755.766 461.51 756.292 461.189 756.622C460.85 756.947 460.315 756.947 459.976 756.622L396.287 702.043C395.326 701.195 395.233 699.728 396.081 698.766C396.5 698.296 397.094 698.019 397.723 697.999C398.353 697.98 398.962 698.22 399.41 698.662Z",
    fill: "url(#paint7_linear)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M900.196 555.57L948.581 600.007C948.707 600.129 948.779 600.297 948.779 600.472C948.779 600.647 948.707 600.815 948.581 600.936C948.46 601.062 948.292 601.134 948.117 601.134C947.942 601.134 947.774 601.062 947.652 600.936L897.615 558.254C897.237 557.943 897.003 557.49 896.969 557.002C896.935 556.514 897.103 556.033 897.434 555.673C897.762 555.253 898.259 554.999 898.791 554.979C899.323 554.959 899.837 555.176 900.196 555.57Z",
    fill: "url(#paint8_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M918.26 572.576L947.91 599.801C948.061 599.96 948.061 600.209 947.91 600.369C947.751 600.519 947.502 600.519 947.343 600.369L916.711 574.227C916.502 574.019 916.384 573.736 916.384 573.44C916.384 573.145 916.502 572.862 916.711 572.653C916.904 572.435 917.178 572.303 917.469 572.289C917.761 572.274 918.045 572.378 918.26 572.576Z",
    fill: "url(#paint9_linear)"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M157.971 628.729L291.8 751.616C292.495 752.336 292.495 753.477 291.8 754.196C291.124 754.931 289.991 755.01 289.219 754.377L151.236 636.161C150.224 635.289 149.604 634.048 149.511 632.715C149.419 631.382 149.864 630.068 150.746 629.065C151.643 628.035 152.923 627.417 154.287 627.354C155.651 627.29 156.982 627.787 157.971 628.729Z",
    fill: "url(#paint10_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M207.983 675.747L289.994 751.048C290.433 751.491 290.433 752.205 289.994 752.648C289.785 752.858 289.502 752.976 289.206 752.976C288.911 752.976 288.628 752.858 288.419 752.648L203.854 680.211C202.567 679.091 202.428 677.141 203.544 675.85C204.11 675.231 204.903 674.869 205.742 674.85C206.58 674.83 207.39 675.155 207.983 675.747Z",
    fill: "url(#paint11_linear)"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M112.244 642.045L173.636 698.43C173.796 698.586 173.887 698.8 173.887 699.024C173.887 699.248 173.796 699.462 173.636 699.617C173.48 699.778 173.266 699.869 173.042 699.869C172.818 699.869 172.604 699.778 172.449 699.617L109.121 645.425C108.16 644.577 108.067 643.11 108.915 642.148C109.334 641.678 109.928 641.401 110.557 641.382C111.187 641.362 111.796 641.602 112.244 642.045Z",
    fill: "url(#paint12_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M135.185 663.618L172.836 698.172C173.032 698.373 173.032 698.694 172.836 698.895C172.743 698.996 172.612 699.054 172.474 699.054C172.337 699.054 172.206 698.996 172.113 698.895L133.404 665.657C133.138 665.395 132.988 665.037 132.988 664.663C132.988 664.29 133.138 663.932 133.404 663.67C133.904 663.216 134.66 663.194 135.185 663.618Z",
    fill: "url(#paint13_linear)"
  })))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.71 646.303L1167.13 702.688C1167.45 703.019 1167.45 703.545 1167.13 703.875C1166.8 704.197 1166.27 704.197 1165.94 703.875L1102.62 649.683C1102.16 649.281 1101.87 648.711 1101.84 648.101C1101.8 647.49 1102 646.89 1102.41 646.432C1102.82 645.967 1103.41 645.69 1104.03 645.666C1104.66 645.641 1105.26 645.871 1105.71 646.303Z",
    fill: "url(#paint14_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.65 667.876L1166.3 702.43C1166.5 702.631 1166.5 702.952 1166.3 703.153C1166.21 703.254 1166.08 703.312 1165.94 703.312C1165.81 703.312 1165.67 703.254 1165.58 703.153L1126.87 669.915C1126.59 669.671 1126.41 669.322 1126.39 668.949C1126.37 668.575 1126.49 668.207 1126.74 667.928C1127.27 667.409 1128.1 667.386 1128.65 667.876Z",
    fill: "url(#paint15_linear)"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M531.974 472.295C531.848 516.314 497.574 552.676 453.639 555.402C409.704 558.129 371.198 526.283 365.63 482.617C365.208 479.192 364.992 475.745 364.985 472.295C364.455 442.115 380.251 413.998 406.303 398.753C432.354 383.508 464.605 383.508 490.656 398.753C516.708 413.998 532.504 442.115 531.974 472.295Z",
    fill: "url(#paint17_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M524.826 438.412C484.465 417.767 470.634 426.387 427.512 441.741C402.868 450.541 384.881 442.825 373.991 434.593C388.566 405.837 418.387 388.035 450.615 388.851C482.843 389.667 511.725 408.955 524.826 438.412Z",
    fill: "url(#paint18_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M528.774 495.365C517.79 533.459 481.542 558.585 442.016 555.502C402.49 552.42 370.576 521.979 365.63 482.643C380.473 496.645 400.466 503.851 420.829 502.539C464.698 499.958 498.426 468.992 528.774 495.365Z",
    fill: "url(#paint19_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1447.95 913.65C1434 954.733 1390.53 977.907 1348.65 966.588C1306.76 955.27 1280.88 913.354 1289.53 870.838C1292.8 854.802 1300.79 840.109 1312.47 828.646C1339.61 801.934 1381.54 797.365 1413.8 817.604C1446.06 837.843 1460.19 877.59 1447.95 913.65Z",
    fill: "url(#paint21_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1451.97 879.793C1420.85 847.742 1405.19 851.407 1360.13 852.206C1334.33 852.645 1320.03 839.768 1312.47 828.646C1335.14 806.424 1368.57 799.228 1398.38 810.155C1428.18 821.083 1449.04 848.184 1451.97 879.793Z",
    fill: "url(#paint22_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.39 262.107L1066.51 476.862L1036.97 455.727L1189.81 240.972C1200.81 225.557 1214.04 211.874 1229.09 200.38L1241.73 190.754C1242.06 190.505 1242.42 190.297 1242.79 190.135C1244.7 189.146 1247.03 189.446 1248.62 190.888C1250.22 192.329 1250.76 194.611 1249.97 196.612L1244.99 211.709C1239.03 229.699 1230.4 246.689 1219.39 262.107Z",
    fill: "url(#paint28_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1211.95 256.843L1059.08 471.572L1036.97 455.728L1189.81 240.973C1200.81 225.557 1214.04 211.874 1229.09 200.38L1241.73 190.755C1242.06 190.505 1242.42 190.297 1242.79 190.135C1242.75 190.54 1242.67 190.938 1242.53 191.322L1237.58 206.419C1231.62 224.418 1222.98 241.416 1211.95 256.843Z",
    fill: "#FFECFF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.61 257.798L1060.73 472.553L1038.49 456.708L1191.34 241.901C1202.29 226.506 1215.5 212.84 1230.51 201.361L1243.15 191.709C1243.48 191.46 1243.83 191.251 1244.21 191.09C1244.17 191.495 1244.09 191.893 1243.95 192.277L1239 207.399C1233.11 225.376 1224.55 242.366 1213.61 257.798Z",
    fill: "url(#paint29_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.68 499.081L1016.45 464.734L1048.45 439.393L1078.15 460.527L1064.68 499.081Z",
    fill: "url(#paint30_radial)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.91 490.72L1016.45 464.734L1048.45 439.393L1066.38 452.166L1052.91 490.72Z",
    fill: "#CC7DFF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.47 492.191L1016.45 464.734L1051 440.864L1068.94 453.637L1055.47 492.191Z",
    fill: "url(#paint31_radial)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.32 469.541L1056.92 493.452L1055.5 495.45L1021.9 471.538L1023.32 469.541Z",
    fill: "url(#paint32_radial)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.16 438.463L1078.84 459.592L1078.21 460.475L1048.53 439.346L1049.16 438.463Z",
    fill: "url(#paint33_radial)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1326.2 341.176L1173.32 555.931L1143.65 534.796L1296.49 320.041C1307.48 304.613 1320.73 290.929 1335.8 279.449L1348.44 269.823C1348.76 269.574 1349.1 269.366 1349.47 269.204C1351.38 268.224 1353.69 268.523 1355.28 269.956C1356.88 271.389 1357.42 273.657 1356.65 275.655L1351.8 290.777C1345.83 308.762 1337.2 325.751 1326.2 341.176Z",
    fill: "url(#paint34_linear)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1318.76 335.886L1165.99 550.641L1143.72 534.796L1296.57 320.041C1307.56 304.613 1320.81 290.929 1335.87 279.449L1348.52 269.823C1348.83 269.574 1349.18 269.366 1349.55 269.204C1349.52 269.61 1349.44 270.01 1349.29 270.391L1344.34 285.487C1338.4 303.48 1329.78 320.471 1318.76 335.886Z",
    fill: "#DDA9FF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1319.49 336.608L1166.61 551.364L1144.34 535.519L1297.22 320.764C1308.19 305.336 1321.43 291.651 1336.49 280.171L1349.14 270.52C1349.46 270.276 1349.8 270.068 1350.17 269.901C1350.14 270.304 1350.06 270.703 1349.94 271.088L1344.98 286.21C1339.05 304.189 1330.46 321.177 1319.49 336.608Z",
    fill: "url(#paint35_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.49 578.15L1123.26 543.802L1155.28 518.461L1184.96 539.596L1171.49 578.15Z",
    fill: "url(#paint36_radial)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.75 569.763L1123.26 543.802L1155.28 518.461L1173.22 531.235L1159.75 569.763Z",
    fill: "#CC7DFF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.5 571.131L1125.01 545.144L1157.04 519.803L1174.97 532.577L1161.5 571.131Z",
    fill: "url(#paint37_radial)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.12 548.617L1163.72 572.529L1162.3 574.526L1128.7 550.615L1130.12 548.617Z",
    fill: "url(#paint38_radial)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.99 517.519L1185.68 538.647L1185.05 539.53L1155.36 518.402L1155.99 517.519Z",
    fill: "url(#paint39_radial)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1339.43 268.791L1134.15 557.195L1045.61 494.178L1250.89 205.773C1273.13 174.522 1304.01 150.448 1339.74 136.511L1357.99 129.388C1362.26 127.721 1367.08 128.319 1370.81 130.978C1374.54 133.636 1376.67 137.998 1376.49 142.575L1375.74 162.187C1374.28 200.499 1361.66 237.549 1339.43 268.791Z",
    fill: "url(#paint40_linear)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1320.83 255.578L1115.57 543.983L1045.61 494.178L1250.89 205.773C1273.13 174.522 1304.01 150.448 1339.74 136.511L1357.99 129.388L1357.21 148.949C1355.73 187.278 1343.09 224.339 1320.83 255.578Z",
    fill: "#CC7DFF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1321.78 255.836L1116.5 544.241L1046.51 494.436L1251.82 206.031C1274.05 174.786 1304.93 150.713 1340.65 136.769L1358.89 129.646L1358.14 149.207C1356.66 187.531 1344.02 224.588 1321.78 255.836Z",
    fill: "url(#paint41_linear)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.94 502.539L1016.4 456.863L1060.11 398.826L1198.12 364.556L1105.94 502.539Z",
    fill: "#FFDCFF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.67 504.578L1019.75 454.282L1058.46 403.419L1199.85 366.569L1107.67 504.578Z",
    fill: "url(#paint43_radial)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1119 511.674L1192.5 582.201L1232.01 521.042L1219.21 379.394L1119 511.674Z",
    fill: "#FFE4FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.29 507.133L1064.09 484.14L1016.4 456.863L1058.46 403.419L1129.81 385.691L1196.47 369.149L1104.29 507.133Z",
    fill: "url(#paint44_radial)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.09 484.14L1016.4 456.863L1058.46 403.419L1129.81 385.691L1064.09 484.14Z",
    fill: "url(#paint45_radial)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.5 582.201L1150.69 545.738L1116.19 515.597L1216.42 383.343L1222.53 450.953L1229.22 524.964L1192.5 582.201Z",
    fill: "url(#paint46_radial)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.5 582.201L1150.69 545.738L1222.53 450.953L1229.22 524.964L1192.5 582.201Z",
    fill: "url(#paint47_radial)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1289.63 329.641L1143.34 535.157L1076.94 487.881L1223.23 282.365C1241.14 257.156 1264.46 236.276 1291.49 221.257C1297.29 218.057 1303.28 215.089 1309.4 212.431C1309.86 212.251 1310.3 212.07 1310.74 211.941C1314.82 210.671 1319.27 211.507 1322.62 214.174C1325.96 216.841 1327.76 220.992 1327.43 225.257C1326.92 231.811 1326.12 238.314 1324.98 244.74C1319.68 275.323 1307.6 304.332 1289.63 329.641Z",
    fill: "url(#paint48_linear)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.91 317.615L1126.61 523.184L1076.94 487.83L1223.23 282.313C1241.14 257.123 1264.46 236.261 1291.49 221.257C1297.29 218.057 1303.28 215.089 1309.4 212.431C1309.86 212.251 1310.3 212.07 1310.74 211.941C1310.76 212.414 1310.76 212.887 1310.74 213.36C1310.22 219.915 1309.42 226.418 1308.16 232.844C1302.88 263.409 1290.79 292.398 1272.8 317.667L1272.91 317.615Z",
    fill: "#FFE4FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1274.79 318.699L1128.5 524.216L1078.8 488.836L1225.09 283.32C1243.02 258.151 1266.35 237.308 1293.37 222.315C1299.18 219.089 1305.16 216.121 1311.28 213.463C1311.72 213.273 1312.17 213.109 1312.62 212.973C1312.62 213.438 1312.62 213.902 1312.62 214.392C1312.11 220.947 1311.29 227.45 1310.17 233.902C1304.86 264.451 1292.78 293.425 1274.82 318.699H1274.79Z",
    fill: "url(#paint49_linear)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.7 567.724L1049.66 508.603C1048.21 507.568 1047.33 505.918 1047.27 504.138C1047.21 502.358 1047.98 500.652 1049.35 499.52L1107.18 451.934C1115.22 445.341 1126.68 444.95 1135.16 450.979L1159.16 468.063C1167.64 474.081 1171.02 485.044 1167.41 494.797L1141.4 565.04C1140.78 566.714 1139.42 568.005 1137.72 568.531C1136.01 569.057 1134.16 568.759 1132.7 567.724Z",
    fill: "#FFE7FF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.34 498.281L1138.82 567.234C1138.19 568.862 1136.85 570.109 1135.18 570.613C1133.51 571.118 1131.7 570.823 1130.28 569.815L1092.91 543.235L1086.95 539.003L1048.71 511.829C1047.28 510.809 1046.42 509.185 1046.36 507.435C1046.31 505.685 1047.07 504.008 1048.42 502.9L1105.2 456.192C1113.07 449.706 1124.32 449.314 1132.63 455.237L1140.24 460.682L1149.53 467.263L1156.21 472.037C1164.54 477.946 1167.87 488.701 1164.34 498.281Z",
    fill: "url(#paint50_linear)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.52 512.885L1077.18 531.859L1074.48 535.643L1047.82 516.669L1050.52 512.885Z",
    fill: "#7C26A4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.06 547.429L1125.72 566.403L1123.03 570.187L1096.37 551.213L1099.06 547.429Z",
    fill: "#7C26A4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1292.73 285.513C1292.06 285.044 1291.62 284.328 1291.49 283.526C1289.33 270.785 1277.27 262.196 1264.52 264.327C1262.86 264.605 1261.29 263.484 1261.01 261.823C1260.73 260.163 1261.85 258.592 1263.51 258.314C1271.25 256.992 1279.19 258.801 1285.58 263.342C1291.98 267.884 1296.3 274.784 1297.6 282.52C1297.74 283.329 1297.54 284.157 1297.05 284.818C1296.57 285.478 1295.83 285.915 1295.02 286.029C1294.22 286.188 1293.39 286 1292.73 285.513Z",
    fill: "url(#paint51_linear)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1324.98 244.688C1320.26 231.502 1309.5 223.476 1291.44 221.205C1297.24 218.005 1303.23 215.038 1309.34 212.38C1313.51 210.54 1318.34 211.037 1322.05 213.685C1325.76 216.334 1327.8 220.742 1327.41 225.282C1326.92 231.76 1326.12 238.263 1324.98 244.688Z",
    fill: "url(#paint52_linear)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.6 455.573C1144.94 455.284 1148.88 458.09 1150.02 462.282L1080.35 555.879C1079.86 556.636 1079.08 557.157 1078.19 557.318C1077.31 557.479 1076.4 557.267 1075.67 556.731C1074.22 555.694 1073.87 553.687 1074.87 552.215L1140.6 455.573Z",
    fill: "url(#paint53_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 411.513,
    cy: 484.14,
    r: 220.665,
    transform: "rotate(-45 411.513 484.14)",
    fill: "url(#paint54_radial)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.42,
    style: {
      mixBlendMode: "screen"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1327.45,
    cy: 877.22,
    r: 220.665,
    transform: "rotate(-45 1327.45 877.22)",
    fill: "url(#paint55_radial)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M519.845 851.845C519.845 861.964 511.642 870.167 501.523 870.167C491.404 870.167 483.201 861.964 483.201 851.845C483.201 841.726 491.404 833.523 501.523 833.523C511.642 833.523 519.845 841.726 519.845 851.845Z",
    fill: "url(#paint56_radial)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M660.718 521.197C660.718 528.62 656.245 535.312 649.386 538.15C642.527 540.989 634.633 539.414 629.387 534.161C624.142 528.908 622.579 521.012 625.427 514.157C628.275 507.302 634.973 502.838 642.396 502.849C647.26 502.849 651.924 504.783 655.361 508.224C658.798 511.666 660.725 516.333 660.718 521.197Z",
    fill: "url(#paint57_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(779.089 551.105) scale(696.857 386.36)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1093.25 331.344) scale(1051.79 552.412)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1241.48 633.761) scale(1550.74 913.857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 1128.31,
    y1: 783.722,
    x2: 1114.46,
    y2: 834.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EA47AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 247.502,
    y1: 566.339,
    x2: 289.102,
    y2: 551.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EA47AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 177.493,
    y1: 543.128,
    x2: 199.653,
    y2: 596.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EA47AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 515.543,
    y1: 710.109,
    x2: 421.323,
    y2: 605.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EA47AC",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: -2735.13,
    y1: 1996.02,
    x2: -2648.09,
    y2: 1996.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EA47AC",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: -2996.13,
    y1: 2427.5,
    x2: -2927.93,
    y2: 2427.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EA47AC",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: -2995.25,
    y1: 2415.74,
    x2: -2953.45,
    y2: 2415.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EA47AC",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: -2607.01,
    y1: 1930.51,
    x2: -2418.45,
    y2: 1930.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EA47AC",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: -2604.58,
    y1: 1897.94,
    x2: -2489.02,
    y2: 1897.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EA47AC",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: -2482.37,
    y1: 1847.35,
    x2: -2395.84,
    y2: 1847.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EA47AC",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: -2481.26,
    y1: 1832.44,
    x2: -2428.23,
    y2: 1832.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EA47AC",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: -3227.97,
    y1: 2503.96,
    x2: -3141.44,
    y2: 2503.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EA47AC",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: -3226.86,
    y1: 2489.06,
    x2: -3173.83,
    y2: 2489.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EA47AC",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(473.266 471.03) scale(166.447)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67219E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6B27A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#8D59B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AC86CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C6ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DACAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EBE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FDFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 364.985,
    y1: 556.404,
    x2: 531.974,
    y2: 556.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EA47AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 373.991,
    y1: 445.634,
    x2: 524.826,
    y2: 445.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDA1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F57AAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EF5EAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#EB4DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EA47AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 365.63,
    y1: 555.767,
    x2: 528.774,
    y2: 555.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FA93AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F372AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EE5AAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EB4CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EA47AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1382.3 920.27) rotate(86.71) scale(163.918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67219E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6B27A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#8D59B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AC86CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C6ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DACAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EBE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FDFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 1269.59,
    y1: 939.736,
    x2: 1425.81,
    y2: 992.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 1277.3,
    y1: 850.7,
    x2: 1359.97,
    y2: 947.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#CA38BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#A02EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8127A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#6E23A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1117.39 463.489) scale(222.187 164.392)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67219E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6B27A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#8D59B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AC86CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C6ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DACAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EBE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FDFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1173.57 467.111) scale(222.187 164.392)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67219E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6B27A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#8D59B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AC86CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C6ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DACAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EBE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FDFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1137.81 504.504) scale(222.187 164.392)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67219E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6B27A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#8D59B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AC86CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C6ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DACAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EBE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FDFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1231.51 346.631) scale(222.187 141.854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67219E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6B27A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#8D59B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AC86CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C6ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DACAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EBE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FDFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1277.82 267.012) scale(222.187 141.854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67219E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6B27A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#8D59B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AC86CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C6ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DACAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EBE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FDFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 1127.05,
    y1: 337.864,
    x2: 1159.98,
    y2: 350.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A02CC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F2CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7222A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#521B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3E1786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#371582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 465.214,
    y1: -709.312,
    x2: 492.543,
    y2: -709.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A02CC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F2CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7222A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#521B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3E1786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#371582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1041.91 417.873) rotate(35.44) scale(74.1398 73.375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A02CC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#371582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(422.377 -1298.21) scale(66.011 64.5506)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A02CC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#371582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1020.18 466.258) rotate(35.44) scale(40.3085 2.39631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A02CC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#371582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1047.39 433.804) rotate(35.44) scale(35.4715 1.0551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#371582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A02CC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 596.178,
    y1: -702.131,
    x2: 632.616,
    y2: -702.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A02CC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F2CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7222A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#521B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3E1786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#371582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 597.185,
    y1: -706.508,
    x2: 624.513,
    y2: -706.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A02CC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F2CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7222A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#521B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3E1786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#371582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(553.986 -1295.37) scale(74.1398 71.7212)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A02CC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#371582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(557.779 -1295.32) scale(63.8175 65.5646)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A02CC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#371582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1126.96 545.32) rotate(35.44) scale(40.3085 2.39631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A02CC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#371582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1153.78 512.582) rotate(35.44) scale(35.4715 1.0551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#371582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A02CC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 1161.77,
    y1: 354.127,
    x2: 1259.46,
    y2: 395.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A02CC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#371582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 1166.43,
    y1: 345.961,
    x2: 1243.88,
    y2: 377.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A02CC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#371582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 1106.27,
    y1: 339.146,
    x2: 1185.95,
    y2: 462.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1151.05 260.13) rotate(35.3625) scale(186.244 176.323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67219E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DE3DBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1145.13 257.1) rotate(35.44) scale(230.703 218.571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1108.41 317.315) rotate(35.44) scale(156.228 150.529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1239.15 324.016) rotate(35.44) scale(230.703 313.508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1239.97 409.961) rotate(35.44) scale(157.079 205.866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 1404.92,
    y1: 382.167,
    x2: 1268.05,
    y2: 330.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 1170,
    y1: 375.069,
    x2: 1225.01,
    y2: 397.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 1046.36,
    y1: 570.88,
    x2: 1165.74,
    y2: 570.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 1247.34,
    y1: 269.983,
    x2: 1274.2,
    y2: 302.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 1282.74,
    y1: 232.704,
    x2: 1323.6,
    y2: 261.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 1117.49,
    y1: 372.668,
    x2: 996.478,
    y2: 460.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67219E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(411.513 484.14) rotate(45) scale(220.665)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#B03097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#822470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A194D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#391031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#20091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0E040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1327.46 877.231) rotate(45) scale(220.665)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#B03097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#822470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A194D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#391031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#20091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0E040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(501.523 851.845) scale(18.3221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#B03097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#822470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A194D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#391031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#20091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0E040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(642.396 521.197) scale(18.3221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DE3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#B03097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#822470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A194D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#391031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#20091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0E040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadMap);
export default __webpack_public_path__ + "static/media/road-map.69decb5f3cea093e5e495b007fb1439d.svg";
export { ForwardRef as ReactComponent };